<mat-drawer-container class="example-container" [hasBackdrop]="true">
  <mat-drawer #drawer [mode]="'over'" [position]="'end'" class="map-table-drawer">
    <ebw-monorepo-map-table-feature-detail
      [details]="details"
      [index]="currentDetailIndex"
      (changeDetail)="onDetailRequestFromDrawer($event)"
      (close)="drawer.toggle()"
    ></ebw-monorepo-map-table-feature-detail>
  </mat-drawer>
  <mat-drawer-content>
    <div class="map-table-content">
      <div class="row">
        <div class="col">
          <div class="d-flex flex-row">
            <div class="d-inline-flex align-items-center">
              <mat-button-toggle-group
                name="fontStyle"
                aria-label="Font Style"
                class="custon-toggle-btn"
                #group="matButtonToggleGroup"
                value="{{ selectedButton }}"
                *ngIf="groupButtons && groupButtons.length > 1"
                (change)="getInitTableFromName($event)"
              >
                <mat-button-toggle [value]="btn.name" *ngFor="let btn of groupButtons" [ngClass]="'px-2 width-fit'">
                  <!-- TODO: GESTIRE GLI SVG -->
                  <mat-icon svgIcon="{{ btn.icon }}" *ngIf="btn.isSvg; else notSvg"></mat-icon>
                  <ng-template #notSvg>
                    <mat-icon class="mr-1 me-1">
                      <span class="material-symbols-outlined">
                        {{ btn.icon }}
                      </span>
                    </mat-icon>
                  </ng-template>
                  <span class="text-capitalize-first">{{ btn.label }}</span>
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div class="p-2">
              <div class="carousel" *ngIf="config.showLevels">
                <a
                  [class.disabled]="levels == 1"
                  (click)="increasesLevel('prev')"
                  class="previous round reactive-padding"
                  >&#8249;</a
                >
                <span> {{ levels + '° ' + ('map.map_table.level' | translate) }}</span>
                <a [class.disabled]="levels == 2" (click)="increasesLevel('next')" class="next round reactive-padding"
                  >&#8250;</a
                >
              </div>
            </div>
            <div class="p-2 ms-auto" *ngIf="dataGrid && dataGrid.length > 0">
              <!-- async export dropdown menu -->
              <button
                *ngIf="isQuery && canExportAdvanced"
                mat-button
                class="reactive-padding"
                matTooltip="{{ 'map.map_table.export_tooltip' | translate }}"
                (click)="onQueryExport()"
              >
                <mat-icon>download</mat-icon>
                {{ 'map.map_table.export' | translate }}
              </button>
              <button
                *ngIf="!isQuery || !canExportAdvanced"
                mat-button
                [matMenuTriggerFor]="menuSync"
                class="reactive-padding"
              >
                <mat-icon>download</mat-icon>
                {{ 'map.map_table.export' | translate }}
              </button>
              <mat-menu #menuSync="matMenu">
                <button mat-menu-item (click)="export('pdf')">
                  {{ 'map.map_table.export_pdf' | translate }}
                </button>
                <button mat-menu-item (click)="export('csv')">
                  {{ 'map.map_table.export_csv' | translate }}
                </button>
                <button mat-menu-item (click)="export('excel')">
                  {{ 'map.map_table.export_excel' | translate }}
                </button>
              </mat-menu>
              <button
                mat-button
                [matTooltip]="'map.map_table.show_on_map_pinned' | translate"
                (click)="hightlightPinnedItem()"
                *ngIf="config.pinnableRow"
              >
                <svg width="25" height="25" viewBox="0 0 582 582" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M36.4554 0.0917969C16.3723 0.0917969 0.0917969 16.3724 0.0917969 36.4554V145.546H36.4554V36.4554H145.546V0.0917969H36.4554V0.0917969Z"
                    fill="#252440"
                  />
                  <path
                    d="M545.546 436.455V545.546H436.455V581.91H531.91C559.524 581.91 581.91 559.524 581.91 531.91V436.455H545.546Z"
                    fill="#252440"
                  />
                  <path
                    d="M545.546 0.0917969C565.629 0.0917969 581.91 16.3724 581.91 36.4554V145.546H545.546V36.4554H436.455V0.0917969H545.546V0.0917969Z"
                    fill="#252440"
                  />
                  <path
                    d="M36.4554 436.455V545.546H145.546V581.91H50.0918C22.4775 581.91 0.0917969 559.524 0.0917969 531.91V436.455H36.4554Z"
                    fill="#252440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M227.429 306.42C227.429 325.923 211.574 341.72 192 341.72C172.426 341.72 156.571 325.923 156.571 306.42C156.571 286.916 172.426 271.12 192 271.12C211.574 271.12 227.429 286.916 227.429 306.42ZM192 479.05C192 479.05 103.429 355.5 103.429 302.55C103.429 253.889 143.162 214.3 192 214.3C240.838 214.3 280.571 253.889 280.571 302.55C280.571 355.5 192 479.05 192 479.05ZM192 179C123.517 179 68 234.315 68 302.55C68 370.785 192 532 192 532C192 532 316 370.785 316 302.55C316 234.315 260.483 179 192 179Z"
                    fill="#252440"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M418.071 165.406C418.071 179.55 406.628 191.006 392.5 191.006C378.372 191.006 366.929 179.55 366.929 165.406C366.929 151.262 378.372 139.806 392.5 139.806C406.628 139.806 418.071 151.262 418.071 165.406ZM392.5 73C343.07 73 303 113.115 303 162.6C303 212.085 392.5 329 392.5 329C392.5 329 482 212.085 482 162.6C482 113.115 441.93 73 392.5 73Z"
                    fill="#252440"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div *ngIf="currentTab" class="p-3 row">
        {{ currentTab.tab_description }}
      </div> -->

      <mtx-grid
        [data]="dataGrid"
        [columns]="columnsGrid"
        [showColumnMenuHeader]="false"
        [headerTemplate]="headerTpl"
        [hidePageSize]="true"
        [noResultText]="'common.no_result' | translate"
        [showFirstLastButtons]="false"
        [rowStriped]="true"
        [showPaginator]="false"
        [emptyValuePlaceholder]="'-'"
        [pageSize]="tableLimitSize"
        [rowClassFormatter]="rowClassFormatter"
      >
      </mtx-grid>

      <ng-container>
        <mat-paginator
          [pageSize]="paginationLimitSize"
          [pageSizeOptions]="pageSizeOptions"
          (page)="onPagination($event)"
          *ngIf="config.pagination"
          [length]="dataSize"
          [pageIndex]="currentPage"
        >
        </mat-paginator>
      </ng-container>

      <ng-template #headerTpl let-col>
        <ng-container [ngSwitch]="col.field">
          <button mat-icon-button color="primary" *ngSwitchCase="'geometry'">
            <mat-icon class="material-symbols-outlined">{{ config.marker ? config.marker : 'place' }}</mat-icon>
          </button>

          <button mat-icon-button color="accent" *ngSwitchCase="'id'">
            <mat-icon class="material-symbols-outlined">info</mat-icon>
          </button>

          <div class="round-box" *ngSwitchCase="'selected'">
            <input
              #selectAllPin
              id="checkbox_pin_all"
              type="checkbox"
              name="pinRow"
              class="pin-check"
              [checked]="isAllSelected()"
              (click)="$event.stopPropagation()"
              (change)="selectDeselectAll(selectAllPin.checked)"
            />
            <label for="checkbox_pin_all"> </label>
          </div>

          <div *ngSwitchDefault>
            {{ col.header }}
          </div>
        </ng-container>
      </ng-template>

      <ng-template #geometryColTemplate let-row let-index="index" let-col="colDef">
        <ng-container [ngSwitch]="config.marker">
          <button
            mat-icon-button
            color="primary"
            (click)="onCenterMapPlaceRequested($event, row)"
            *ngSwitchCase="'place'"
            [matTooltip]="'map.map_table.show_on_map' | translate"
          >
            <mat-icon>place</mat-icon>
          </button>
          <div class="round-box" *ngSwitchDefault>
            <input
              id="{{ 'checkbox' + index }}"
              type="radio"
              name="selector"
              class="checkbox-round"
              (click)="$event.stopPropagation()"
              (change)="centerMapMarker($event, row, index + 1)"
            />
            <label for="{{ 'checkbox' + index }}" class="center-number">{{ index + 1 }}</label>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #infoColTemplate let-row let-index="index" let-col="colDef">
        <button
          mat-icon-button
          color="accent"
          [matTooltip]="'map.map_table.show_detail' | translate"
          (click)="onDetailRequest($event, row.id, index)"
        >
          <mat-icon>info</mat-icon>
        </button>
      </ng-template>

      <ng-template #pinnableRowColTemplate let-row let-index="index" let-col="colDef">
        <input
          #pinCheckbox
          id="{{ 'checkbox_pin' + index }}"
          type="checkbox"
          name="pinRow"
          class="pin-check"
          [checked]="isSelected(row.id)"
          (click)="$event.stopPropagation()"
          (change)="onPinChecked(pinCheckbox.checked, row, index)"
          [matTooltip]="'map.map_table.pin' | translate"
        />
        <label for="{{ 'checkbox_pin' + index }}"> </label>
      </ng-template>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
